import { styled, RcDialog } from '@ringcentral/juno';
import { onMobile } from '@/core/sc';

export const LoginOptionDialog = styled(RcDialog)`
  [class~='MuiDialog-paper'] {
    ${onMobile} {
      max-width: none !important;
      max-height: none !important;
      width: 100% !important;
      height: 100% !important;
      margin: 0 !important;
      border-radius: 0 !important;
    }
  }
`;
